import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { AcumaticaService } from '../acumatica/acumatica.service';
import { Component, Inject, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { ApplicationScreen, ScreenContextMenuItem } from './application-screen';
import { FormControl } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { UpToDateBuildService } from '../services/up-to-date-build.service';
import { AlertDialog } from '../common/alert-dialog/alert-dialog.component';
import { APP_MENU_ITEMS } from '../app.module';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'application-navigator',
  templateUrl: './application-navigator.component.html',
  styleUrls: ['./application-navigator.component.css']
})
export class NavMenuComponent implements OnInit {
  environment = environment; // make environment variables available to template
  component: any;
  pageTitle: string = "Mayer Fabrics";
  username: string | null;
  screenMenuItems?: ScreenContextMenuItem[];
  buildIsUpToDate: boolean = true;
  currentRoute?: string;

  @ViewChild('sideNavMenuOutlet', { read: ViewContainerRef }) sideNavMenuOutlet!: ViewContainerRef;
  @ViewChild('sideNavContextMenuContent', { read: TemplateRef }) sideNavContextMenuContent!: TemplateRef<any>;

  constructor(
    public acumatica: AcumaticaService,
    private router: Router,
    private dialog: MatDialog,
    private titleService: Title,
    private upToDateService: UpToDateBuildService,
    @Inject(APP_MENU_ITEMS) public menuItems: any
  ) {
    this.username = acumatica.username;

    acumatica.loginStatusChange.subscribe(result => {
      if (result.loggedin) {
        this.username = acumatica.username;
      } else {
        this.username = null;
        if (!result.fromLogin && result.redirectLoggedOutToLogin) this.router.navigate(['/login']);
      }
    });

    this.upToDateService.buildIsUpToDate.subscribe(buildIsUpToDate => {
      this.buildIsUpToDate = buildIsUpToDate;
    });

    // track current page url into page-template accessible variable
    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) this.currentRoute = event.url;
    });
  }

  ngOnInit(): void {
    document.addEventListener('fullscreenchange', () => {
      this.inFullscreen = document.fullscreenElement != null;
    });
  }
  inFullscreen: boolean = false;
  enableFullscreen() { document.querySelector("body")?.requestFullscreen(); }

  componentHasPageTitle(component: any): component is ApplicationScreen {
    return 'pageTitle' in component;
  }

  onActivate(component: any) {
    this.component = component;
    this.screenMenuItems = [];

    // if the 'page' implements NavMenuItem
    if (this.componentHasPageTitle(component)) {

      // the pageTitle may be a simple string
      if (typeof (component.pageTitle) == 'string') {
        this.titleService.setTitle(component.pageTitle);
        this.pageTitle = component.pageTitle;
      }

      // the pageTitle may be a FormControl   pageTitle = new FormControl("Pick Shipment");
      else {
        this.pageTitle = component.pageTitle.value;
        this.titleService.setTitle(component.pageTitle.value);
        // which can be changed    this.pageTitle.setValue("Picking: " + this.shipmentNbr.value);
        component.pageTitle.registerOnChange(() => {
          let title = (<FormControl>component.pageTitle).value;
          this.pageTitle = title;
          this.titleService.setTitle(title);
        })
      }

      this.screenMenuItems = component.screenMenuItems;
    } else {
      this.titleService.setTitle((environment.mode == 'rep' ? 'Mayer Rep' : 'Mayer WMS'));
      this.pageTitle = "Mayer Fabrics " + (environment.mode == 'rep' ? 'Sales Rep' : 'WMS');
    }
  }

  /** function implemented by Template to evaluate the condition parameter which may be a boolean value or a function that returns a boolean value or undefined */
  evaluateMenuItemCondition(menuItem: ScreenContextMenuItem) {
    return (typeof menuItem.condition === 'function' ? menuItem.condition() : menuItem.condition) !== false
  }

  doLogout() {
    this.acumatica.Logout();
  }

  systemUpdate() {
    this.dialog.open(AlertDialog, {
      data: {
        message: this.upToDateService.buildVersionMessage,
        buttonText: "OK"
      }
    });
  }
}